import { useQuery } from '@hooks/reactQuery';

import { getHistoryCheckNodes } from '@api/hitoryCheck';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedWithArray } from '@utils/formatter';

import { ICMMavenirVendor } from '@interfaces/cmModule/cmModule';
import { IVendor } from '@interfaces/cmModule/dto/cmModuleDTO';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { HISTORY_CHECK_NODES } from '@constants/queryKeys';

type TUseQueryHistoryCheckNodes = ICMMavenirVendor & IVendor

interface IUseQueryHistoryCheckNodesReturnValue {
	nodesOptions: TSelectOption<string>[];
	isLoadingNodesOptions: boolean;
}

export const useQueryHistoryCheckNodes = ({
	vendor,
	isMavenirVendor,
}: TUseQueryHistoryCheckNodes): IUseQueryHistoryCheckNodesReturnValue => {
	const {
		data,
		isFetching,
		isLoading,
	} = useQuery<string[], TSelectOption<string>[]>({
		queryKey: [HISTORY_CHECK_NODES, vendor],
		queryFn: extractQueryParams(getHistoryCheckNodes),
		select: (options) => optionsFormattedWithArray(options),
		enabled: [!!vendor, isMavenirVendor],
		...refetchOptions,
	});

	return {
		nodesOptions: data || [],
		isLoadingNodesOptions: (isLoading && !!data) || isFetching,
	};
};
